export const AGENCY_BROADCAST_SUBJECT = "New locum doctors needed";

export type BroadcastShiftDay = {
  date: string;
  startTime?: string;
  endTime?: string;
  specialty?: string;
  skillLevel?: string;
  filled?: boolean;
  confirmed?: boolean;
  startMs?: number;
};

export function remainingBroadcastDays(
  days: BroadcastShiftDay[],
  now = Date.now(),
) {
  return days.filter((day) => {
    if (day.confirmed || day.filled) return false;
    const start = day.startMs || Date.parse(day.date);
    if (!Number.isFinite(start)) return true;
    return start > now;
  });
}

export function shouldStopPostShiftAutomation(args: {
  grouped: boolean;
  days: BroadcastShiftDay[];
}) {
  const open = remainingBroadcastDays(args.days);
  if (!args.grouped) {
    return (
      args.days.some((day) => day.confirmed || day.filled) || open.length === 0
    );
  }
  return open.length === 0;
}

export function formatOpenDateLine(day: BroadcastShiftDay) {
  const time =
    day.startTime && day.endTime ? ` ${day.startTime}–${day.endTime}` : "";
  return `• ${day.date}${time}`;
}

export function renderAgencyBroadcast(args: {
  subject?: string;
  body?: string;
  grouped: boolean;
  specialty?: string;
  skillLevel?: string;
  days: BroadcastShiftDay[];
}) {
  const open = remainingBroadcastDays(args.days);
  const specialty = args.specialty || "—";
  const skillLevel = args.skillLevel || "—";
  const openDates = open.length
    ? open.map(formatOpenDateLine).join("\n")
    : "No future open dates left.";
  const subject = (args.subject || AGENCY_BROADCAST_SUBJECT)
    .replace(/new locum shift posted/gi, AGENCY_BROADCAST_SUBJECT)
    .replace(/StatHospital/gi, "StatDoctor");
  const template =
    args.body && !/StatHospital/i.test(args.body)
      ? args.body
      : `${AGENCY_BROADCAST_SUBJECT}.\n\n{{openDates}}\nSpecialty: {{specialty}}\nSkill level: {{skillLevel}}`;
  const heading = args.grouped
    ? `Open dates still needed: ${open.length}`
    : "Open shift";
  const body = template
    .replace(/\{\{openDates\}\}/g, `${heading}\n${openDates}`)
    .replace(/\{\{specialty\}\}/g, specialty)
    .replace(/\{\{skillLevel\}\}/g, skillLevel)
    .replace(/StatHospital/gi, "StatDoctor");
  return { subject, body, open };
}
